<div class="dropdown">
    <button class="btn {{trigger.triggerBtnClasses}}" *ngFor="let trigger of triggerData"
            [matMenuTriggerRestoreFocus]="this.restoreFocus"
            [ngClass]="{'disabled-btn': disabled}"
            [attr.aria-label]="trigger.triggerBtnAriaLabel"
            [disabled]="disabled"
            [matMenuTriggerFor]="menu"
            (mousedown)="openMenu()"
            (keydown)="handleKeyboardEvent($event)">
        <mat-icon class="material-icons-round btn-icon
                icon-color__{{trigger.triggerBtnIconColor}} icon-size__{{trigger.triggerBtnIconSize}}">
            {{trigger.triggerBtnIcon}}
        </mat-icon>
    </button>
    <mat-menu class="mat-menu-dropdown" #menu="matMenu" xPosition="before">
        <button mat-menu-item class="btn dropdown-item {{menuItem.btnCssClasses}}" *ngFor="let menuItem of menuItems"
                [ngClass]="{'disabled-btn': menuItem.disabled}"
                [attr.aria-label]="menuItem.btnAriaLabel"
                [disabled]="menuItem.disabled"
                (click)="buttonEvent.emit(menuItem.key)"
                (keydown)="onKeyDown($event)"
                (keyup)="onTab($event)">
            <mat-icon class="material-icons-round btn-icon
                icon-color__{{menuItem.btnIconColor}} icon-size__{{menuItem.btnIconSize}}">
                {{menuItem.btnIcon}}
            </mat-icon>
            <span class="btn-label btn-label-color__{{menuItem.btnLabelColor}}">
                {{menuItem.btnLabel}}
            </span>
        </button>
    </mat-menu>
</div>
